import { WhiteSpaceGroup, WhiteSpaceLegend, WhiteSpaceStatus } from 'enums';
import { rgbToRgba } from 'utils/color';

// eslint-disable-next-line
import { WhiteSpacePalette } from './main';

export const makeWhiteSpaceLegendTheme = (
  whiteSpacePalette: WhiteSpacePalette,
) => {
  const legend = {
    [WhiteSpaceLegend.ACTIVE]: {
      background:
        whiteSpacePalette[WhiteSpaceGroup.AGREEMENT_TYPE][
          WhiteSpaceStatus.ACTIVE
        ],
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
    [WhiteSpaceLegend.ANNOTATED]: {
      background:
        whiteSpacePalette[WhiteSpaceGroup.AGREEMENT_TYPE][
          WhiteSpaceStatus.ANNOTATED
        ],
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
    [WhiteSpaceLegend.OPEN_OPPORTUNITY]: {
      background:
        whiteSpacePalette[WhiteSpaceGroup.AGREEMENT_TYPE][
          WhiteSpaceStatus.OPEN_OPPORTUNITY
        ],
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
    [WhiteSpaceLegend.AGREEMENT_TYPE_ACTIVE]: {
      background:
        whiteSpacePalette[WhiteSpaceGroup.AGREEMENT_TYPE][
          WhiteSpaceStatus.ACTIVE
        ],
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
    [WhiteSpaceLegend.AGREEMENT_TYPE_PROSPECT]: {
      background: `linear-gradient(90deg, ${rgbToRgba(
        whiteSpacePalette[WhiteSpaceGroup.AGREEMENT_TYPE][
          WhiteSpaceStatus.PROSPECT
        ],
        0,
      )} 15%, ${rgbToRgba(
        whiteSpacePalette[WhiteSpaceGroup.AGREEMENT_TYPE][
          WhiteSpaceStatus.PROSPECT
        ],
        1,
      )} 100%)`,
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
      border: true,
    },
    [WhiteSpaceLegend.AGREEMENT_TYPE_HEADER]: {
      background: whiteSpacePalette[WhiteSpaceGroup.AGREEMENT_TYPE].groupHeader,
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
    [WhiteSpaceLegend.PRODUCT_SUBCATEGORY_ACTIVE]: {
      background:
        whiteSpacePalette[WhiteSpaceGroup.PRODUCT_SUBCATEGORY][
          WhiteSpaceStatus.ACTIVE
        ],
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
    [WhiteSpaceLegend.PRODUCT_SUBCATEGORY_HEADER]: {
      background:
        whiteSpacePalette[WhiteSpaceGroup.PRODUCT_SUBCATEGORY].groupHeader,
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
    [WhiteSpaceLegend.INVOICED_PRODUCT_ACTIVE]: {
      background:
        whiteSpacePalette[WhiteSpaceGroup.INVOICED_PRODUCT][
          WhiteSpaceStatus.ACTIVE
        ],
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
    [WhiteSpaceLegend.INVOICED_PRODUCT_HEADER]: {
      background:
        whiteSpacePalette[WhiteSpaceGroup.INVOICED_PRODUCT].columnHeader,
      $iconColor: '#fff',
      $iconHoverColor: '#fff',
      $iconHoverOpacity: 0.6,
    },
  };

  return legend;
};
